import { render, staticRenderFns } from "./TagArticlesAndQuestions.vue?vue&type=template&id=e952de24&"
import script from "./TagArticlesAndQuestions.vue?vue&type=script&lang=js&"
export * from "./TagArticlesAndQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports